'use client';

import React from 'react';

interface TeamMember {
  name: string;
  role: string;
  img: string;
  delay: number;
}

const teamMembers: TeamMember[] = [
  {
    name: 'Rohitkumar Rajmjibhai Chaudhari',
    role: 'Founder',
    img: '/assets/img/team/team-1.jpg',
    delay: 100,
  },
  {
    name: 'Jayanaben Rohitkumar Chaudhari',
    role: 'Co-Founder',
    img: '/assets/img/team/team-2.jpg',
    delay: 200,
  },
  {
    name: 'William Anderson',
    role: 'CTO',
    img: '/assets/img/team/team-3.jpg',
    delay: 300,
  },
  {
    name: 'Amanda Jepson',
    role: 'Accountant',
    img: '/assets/img/team/team-4.jpg',
    delay: 400,
  },
];

export default function TeamSection() {
  return (
    <section id="team" className="team section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Team</h2>
        <p>our Team</p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="col-lg-3 col-md-6 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay={member.delay}
            >
              <div className="team-member">
                <div className="member-img">
                  <img src={member.img} className="img-fluid" alt={member.name} />
                  <div className="social">
                    <a href="#"><i className="bi bi-twitter-x"></i></a>
                    <a href="#"><i className="bi bi-facebook"></i></a>
                    <a href="#"><i className="bi bi-instagram"></i></a>
                    <a href="#"><i className="bi bi-linkedin"></i></a>
                  </div>
                </div>
                <div className="member-info">
                  <h4>{member.name}</h4>
                  <span>{member.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
